import FA from 'admin/components/atoms/FontAwesome';
import Table from 'admin/components/atoms/Table';
import Pager from 'admin/components/shared/Pager';
import { formatDate } from 'admin/utils';
import React from 'react';
import styled from 'styled-components';
import { openAlertModal } from '~/javascripts/admin/actions/alert-modal';
import { getPrivateMoneyExchanges } from '~/javascripts/admin/actions/private-money-exchanges';
import { useAppDispatch } from '~/javascripts/admin/hooks/useApp';

type GetExchangesResponse = Awaited<ReturnType<typeof getPrivateMoneyExchanges>>;

type Props = {
  exchanges: GetExchangesResponse['rows'];
  pagination?: GetExchangesResponse['pagination'];
  onChangePage: (page: number) => void;
  onDeleteItem?: (id: number) => void;
  canEdit?: boolean;
};

const TrashIcon = styled(FA)<{ disabled?: boolean }>`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
`;

const ConfirmDialog = styled.div``;

const ConfirmTitle = styled.p`
  color: #676767;
  font-weight: bold;
`;

const ConfirmContent = styled.div`
  padding: 8px;
  text-align: left;
  p {
    margin-bottom: 8px;
  }
`;

const ListTable = ({ exchanges, pagination, onChangePage, onDeleteItem, canEdit }: Props) => {
  const dispatch = useAppDispatch();

  const onClickDelete = (exchange: (typeof exchanges)[number]) => {
    dispatch(
      openAlertModal({
        body: (
          <ConfirmDialog>
            <ConfirmTitle>以下のマネー交換の設定を削除してよろしいですか？</ConfirmTitle>
            <ConfirmContent>
              <p>
                交換元 <span style={{ width: 32, display: 'inline-block' }} />
                {exchange.sender_money.name}
              </p>
              <p>
                交換先 <span style={{ width: 32, display: 'inline-block' }} />
                {exchange.receiver_money.name}
              </p>
            </ConfirmContent>
          </ConfirmDialog>
        ),
        confirmText: '実行',
        confirmColor: 'danger',
        onConfirm: () => onDeleteItem?.(exchange.id),
      })
    );
  };

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell size="2">ID</Table.Cell>
          <Table.Cell size="3.5">交換元</Table.Cell>
          <Table.Cell size="3.5">交換先</Table.Cell>
          <Table.Cell size="2">作成日</Table.Cell>
          <Table.Cell size="1">削除</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {exchanges?.map((exchange) => (
          <Table.Row key={exchange.id}>
            <Table.Cell wordBreak="keep-all">{exchange.id}</Table.Cell>
            <Table.Cell>{exchange.sender_money.name}</Table.Cell>
            <Table.Cell>{exchange.receiver_money.name}</Table.Cell>
            <Table.Cell>{formatDate(exchange.created_at, 'YYYY/MM/DD')}</Table.Cell>
            <Table.Cell>
              <TrashIcon
                icon="trash-alt"
                disabled={!canEdit}
                onClick={() => canEdit && onClickDelete(exchange)}
              />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan="5" align="center" styles={{ paddingTop: '16px' }}>
            <Pager pagination={pagination} onChangePage={onChangePage} />
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default ListTable;
